module.exports = __webpack_public_path__ + "media/Video 154a.72b79c90.mp4";